import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-legal-consultations',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './legal-consultations.component.html',
  styleUrl: './legal-consultations.component.scss'
})
export class LegalConsultationsComponent {

}
